import { EdgeProps } from "reactflow";
import BaseEdge from "./base/BaseEdge";

export const TaskIdEdge = (edgeProps: EdgeProps) => {
  return <BaseEdge {...edgeProps} color={"purple.600"} isDashed={true} />;
};
